"use strict";

var $ = require("jquery");
var common = require("./common");
var uuid = require("./uuidMIT");

var EMAIL_KEYUP_ABLE = true;

function ForgotPassword (params) {
    this.loginWidgetInstance = params.loginWidgetInstance;
    this.email = params.email;
    this.environment = params.environment;
    this.apigeeKey = params.apigeeKey;
    this.locale = params.language;
    this.forgotPasswordReturnURL = params.forgotPasswordReturnURL;
    this.apiUrl = common.API_ENVIRONMENTS[this.environment] + '/passwords/reset-requests';
}

ForgotPassword.prototype.init = function () {
    var self = this;
    this.forgotPwdParent = this.loginWidgetInstance.forgotPasswordParent.find(".forgot-password");
    this.clearErrorMessages();
    common.hideElement(this.forgotPwdParent.find("#forgotPasswordSuccess"));
    common.showElement(this.forgotPwdParent.find("#forgotPasswordPage"));
    this.emailField = this.forgotPwdParent.find("input#uim-forgotPassword-uEmail-input");
    var submit = this.forgotPwdParent.find("input#uim-forgotPassword-submit");
    var emailInputErrors = this.forgotPwdParent.find("#email-input-errors");
    this.fields = {
        email: this.emailField
    };

    this.emailField.val(this.email);
    this.updateSubmitState();

	this.emailField.on("focus", function () {
		var isEmptyEmail = self.fields.email.val().length === 0;
		if(isEmptyEmail){
			EMAIL_KEYUP_ABLE = true;
			$("div#email-input-area").removeClass("error");
			common.hideElement(emailInputErrors.find(".uim-message.empty-email-input"));
			common.hideElement(emailInputErrors.find(".uim-message.invalid-email-input"));
		}
    });

    this.emailField.on("blur", function () {
		self.validateEmail();
		// EMAIL_KEYUP_ABLE = common.validateRequiredField(self.emailField,emailInputErrors,".uim-message.empty-email-input");
        if(common.validateRequiredField(self.emailField,emailInputErrors,".uim-message.empty-email-input")) {
           // EMAIL_KEYUP_ABLE = self.validateEmail();
        } else {
            common.hideElement(emailInputErrors.find(".uim-message.invalid-email-input"));
        }
        self.updateSubmitState();
    });

    this.emailField.on("keyup", function () {
		if(!EMAIL_KEYUP_ABLE){
			if(common.validateRequiredField(self.emailField,emailInputErrors,".uim-message.empty-email-input")) {
				EMAIL_KEYUP_ABLE = self.validateEmail();
			} else {
				common.hideElement(emailInputErrors.find(".uim-message.invalid-email-input"));
			}

			self.validateEmail();

		}
		self.updateSubmitState();
    });

    submit.off("click enter");
    submit.on("click enter", function (e) {
        e.preventDefault();
        self.forgotPassword({
            email: self.fields.email.val()
        });
    });

    function onCancel (e) {
        e.preventDefault();

		self.forgotPwdParent.find("#email-input-area").removeClass("error");
        self.forgotPwdParent.find("*").off(".forgot-password");
        self.loginWidgetInstance.resetToDefault();
    }

    this.forgotPwdParent.find("input.cancel").on("click.forgot-password", onCancel);
	EMAIL_KEYUP_ABLE = true;
};

ForgotPassword.prototype.updateSubmitState = function() {
    if(this.fields.email.val().length !== 0 && !this.checkValidationErrors()) {
        this.forgotPwdParent.find("input#uim-forgotPassword-submit").removeAttr('disabled');
    } else {
        this.forgotPwdParent.find("input#uim-forgotPassword-submit").attr("disabled", true);
    }
};

ForgotPassword.prototype.checkValidationErrors = function() {
    var submitErrorsElement = this.forgotPwdParent.find("#sendGridSubmit-errors");
    var emailInputErrorsElement = this.forgotPwdParent.find("#email-input-errors");
    return (
        common.checkElement(submitErrorsElement.find(".uim-message.unknown_server_error")) ||
        common.checkElement(emailInputErrorsElement.find(".uim-message.invalid-email-input")) ||
        common.checkElement(emailInputErrorsElement.find(".uim-message.empty-email-input")));
};

ForgotPassword.prototype.validateEmail = function() {
    var isValid = this.emailField[0].validity.valid;
    var email = this.forgotPwdParent.find("input#uim-forgotPassword-uEmail-input");
    var emailInputErrorsElement = this.forgotPwdParent.find("#email-input-errors");

	var isEmptyEmail = email[0].value.length === 0;
	if (isEmptyEmail) {
        email.parent().removeClass("error");
        common.hideElement(emailInputErrorsElement.find(".uim-message.empty-email-input"));
		common.hideElement(emailInputErrorsElement.find(".uim-message.invalid-email-input"));
        //this.clearErrorMessages();
		EMAIL_KEYUP_ABLE = true;
    }else if(isValid){
        email.parent().removeClass("error");
        common.hideElement(emailInputErrorsElement.find(".uim-message.invalid-email-input"));
		EMAIL_KEYUP_ABLE = true;
    } else {
        email.parent().addClass("error");
        common.showElement(emailInputErrorsElement.find(".uim-message.invalid-email-input"));
		EMAIL_KEYUP_ABLE = isValid;
    }
    return isValid;

};

ForgotPassword.prototype.clearErrorMessages = function () {
    var submitErrorsElement = this.forgotPwdParent.find("#sendGridSubmit-errors");
    var emailInputErrorsElement = this.forgotPwdParent.find("#email-input-errors");

    common.hideElement(submitErrorsElement.find(".uim-message.unknown_server_error"));
    common.hideElement(emailInputErrorsElement.find(".uim-message.invalid-email-input"));
    common.hideElement(emailInputErrorsElement.find(".uim-message.empty-email-input"));
};

ForgotPassword.prototype.showInputErrors = function (status) {
    var submitErrorsElement = this.forgotPwdParent.find("#sendGridSubmit-errors");

    common.showElement(submitErrorsElement.find(".uim-message.unknown_server_error"));
};

ForgotPassword.prototype.forgotPassword = function(){
    var self = this;
    $.ajax({
        method: "POST",
        url: this.apiUrl,
        data: JSON.stringify({
            data : {
                type : "password-reset-request",
                attributes : {
                    emailAddress : self.fields.email.val(),
                    locale : self.locale,
                    returnURL: self.forgotPasswordReturnURL
                }
            }
        }),
        headers : {
            ApiKey : this.apigeeKey,
            "X-API-RequestId": uuid()
        }
    }).success(function(data, status) {
        common.showElement(self.forgotPwdParent.find("#forgotPasswordSuccess"));
        common.hideElement(self.forgotPwdParent.find("#forgotPasswordPage"));
        }).error(function(xhr) {
        self.showInputErrors(xhr.status);
    });
};

module.exports = ForgotPassword;



//////////////////
// WEBPACK FOOTER
// ./components/ui-widgets/src/js/forgot-password.js
// module id = 34
// module chunks = 0